<template>
<v-container fluid>
  <div>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <h4>SDAH Arrivals ({{ $route.params.north_south}})</h4>
        </v-col>
          <v-col  cols="12" sm="6" md="3" class="body-2 font-weight-black">
            {{lastupdate}}
                <v-btn text icon color="purple" dark @click.native.stop="initialize()">
                  <v-icon dark>mdi-refresh</v-icon>
                </v-btn>
          </v-col>
         <v-col cols="12" sm="6" md="3">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-btn color="primary" @click="createPDF()">
            <v-icon left dark>mdi-file-pdf</v-icon>Print PDF
          </v-btn>
        </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="850px">
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="400px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="dateFormatted" label="Train Date" hint="DD/MM/YYYY format" persistent-hint required :rules="dateRules" prepend-icon="event" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="train_date" no-title @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <template>
                  <v-data-table :headers="selectableTrainsHeader" :items="selectableTrains" :search="search" :footer-props="{
                    'items-per-page-options': [10, 20, 30, 40, 50]
                    }" :items-per-page="40" sort-by="dep" class="elevation-1" @click:row="saveTrainAdd($event)">
                  </v-data-table>
                </template>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="cancelTrainAdd">Cancel</v-btn>
          <!-- <v-btn color="blue darken-1" text @click="saveTrainAdd" :disabled="!valid">Save</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
   <v-dialog
     v-model="confirm_dialog"
     persistent
     max-width="290"
   >
     <v-card>
       <v-card-title class="headline">
        Confirm Add train
       </v-card-title>
       <v-card-text>
         Selected train :  {{ selectedUpTrain.train_no }} {{ selectedUpTrain.org }} {{ selectedUpTrain.dep }} {{ selectedUpTrain.dest }} {{ selectedUpTrain.arr }}
         <v-text-field v-model="selectedDnTrain.pf" label="PF No" ></v-text-field>
       </v-card-text>
       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn
           color="red darken-1"
           text
           @click="confirmTrainAdd(false)"
         >
           Cancel
         </v-btn>
         <v-btn
           color="green darken-1"
           text
           @click="confirmTrainAdd(true)"
         >
           Add Train
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>
   <v-card>
     <v-card-title class="headline">
      Incoming Rakes/Trains not arrived
     </v-card-title>
     <v-card-text>
    <v-data-table dense :headers="headers" :items="trains" :search="search" :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50, 100, 500]
    }" :items-per-page="40" sort-by="trains" class="elevation-1" :loading="isLoading"
     loading-text="Loading... Please wait" :mobile-breakpoint="100">
     <template v-slot:item.id="{ item }">
       {{trains.map(function(x) {
     return x.id;
     }).indexOf(item.id)+1}}
     </template>
      <template v-slot:item.train_date="{ item }">
        {{getFormattedDate(item.train_date)}}
      </template>
      <template v-slot:item.train_no="{ item }">
        {{item.org}} {{item.train_no}} ({{getFormattedTime(item.dep)}})
      </template>
      <template v-slot:item.dep="{ item }">
        {{getFormattedTime(item.dep)}}
      </template>
      <template v-slot:item.act_arr="{ item }">
        {{getFormattedTime(item.act_arr)}}
      </template>
      <template v-slot:item.arr="{ item }">
        {{getFormattedTime(item.arr)}}
      </template>
      <template v-slot:item.late_dep="{ item }">
        {{getFormattedTimeSec(item.late_dep)}}
      </template>
      <template v-slot:item.late_arr="{ item }">
        <v-chip :color="getColour(item)" dark>{{getFormattedTimeSec(item.late_arr)}}</v-chip>
      </template>
      <template v-slot:item.pf="{ item }">
        <v-chip
         :color='#F5DEB3'
         dark
       >
        PF {{item.pf}}
        </v-chip>
      </template>
      <template v-slot:item.next_train_no="{ item }">
        {{item.next_train_description}} {{item.next_train_no}}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn v-if ="!item.next_train_no" text icon color="purple" dark @click.native.stop="openTrainAdd(item)">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>

        <v-btn text icon color="blue" dark @click.native.stop="editTrains(item)">
          <v-icon dark>mdi-pencil</v-icon>
        </v-btn>
        <v-btn text icon color="green" dark @click.native.stop="onRowClick(item)">
          <v-icon dark>mdi-information</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.pf="props" v-slot:click.native.stop="true">
        <v-edit-dialog :return-value.sync="props.item.pf" large @save="savePF(props.item)" @cancel="cancelPF" @open="open" @close="close"> {{ props.item.pf }}
          <template v-slot:input>
            <v-text-field ref="inputPf" v-model="props.item.pf" @focus="selectText($event)" label="Enter PF No" single-line autofocus counter></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <!-- <template v-slot:item.act_arr="props" v-slot:click.native.stop="true">
        <v-edit-dialog :return-value.sync="props.item.act_arr" large @save="saveActArr(props.item)" @open="openEditActArr(props.item.act_arr)" @close="closeEditActArr"> {{getFormattedTime(props.item.act_arr)}}
          <template v-slot:input>
            <v-datetime-picker ref="editActArr" label="Select Arrival time"
             :text-field-props="textFieldProps"
             :date-picker-props="dateProps"
             :time-picker-props="timeProps"
             date-format="yyyy-MM-dd"
             time-format="HH:mm:ss"
             v-model="act_arr_formatted">
            </v-datetime-picker>
          </template>
        </v-edit-dialog>
      </template> -->
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">No Report, click to retry</v-btn>
      </template>
    </v-data-table>
  </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="addrake">Add Rake in Service</v-btn>
    </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title class="headline">
       Rakes/Trains available at Platforms
      </v-card-title>
      <v-card-text>
    <v-data-table dense :headers="trains_at_pf_headers" :items="trains_avl_at_pf" :search="search" :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50]
    }" :items-per-page="40" sort-by="trains" class="elevation-1" :loading="isLoading"
     loading-text="Loading... Please wait" :mobile-breakpoint="100">
     <template v-slot:item.id="{ item }">
       {{trains_avl_at_pf.map(function(x) {
     return x.id;
     }).indexOf(item.id)+1}}
     </template>
      <template v-slot:item.train_date="{ item }">
        {{getFormattedDate(item.train_date)}}
      </template>
      <template v-slot:item.train_no="{ item }">
        {{item.org}} {{item.train_no}} ({{getFormattedTime(item.dep)}})
      </template>
      <template v-slot:item.dep="{ item }">
        {{getFormattedTime(item.dep)}}
      </template>
      <template v-slot:item.act_arr="{ item }">
        {{getFormattedTime(item.act_arr)}}
      </template>
      <template v-slot:item.arr="{ item }">
        {{getFormattedTime(item.arr)}}
      </template>
      <template v-slot:item.late_dep="{ item }">
        {{getFormattedTimeSec(item.late_dep)}}
      </template>
      <template v-slot:item.act_arr="{ item }">
        {{getFormattedTime(item.time_entering_section)}}
      </template>
      <template v-slot:item.late_arr="{ item }">
        <v-chip :color="getColour(item)" dark>{{getFormattedTimeSec(item.late_arr)}}</v-chip>
      </template>
      <template v-slot:item.pf="{ item }">
        <v-chip
         :color='#F5DEB3'
         dark
       >
        PF {{item.pf}}
        </v-chip>
      </template>
      <template v-slot:item.next_train_no="{ item }">
        {{item.next_train_description}} {{item.next_train_no}} {{getFormattedTime(item.n_dep)}}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn v-if ="!item.next_train_no" text icon color="purple" dark @click.native.stop="openTrainAdd(item)">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>

        <v-btn text icon color="blue" dark @click.native.stop="editTrains(item)">
          <v-icon dark>mdi-pencil</v-icon>
        </v-btn>
        <v-btn text icon color="green" dark @click.native.stop="onRowClick(item)">
          <v-icon dark>mdi-information</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.pf="props" v-slot:click.native.stop="true">
        <v-edit-dialog :return-value.sync="props.item.pf" large @save="savePF(props.item)" @cancel="cancelPF" @open="open" @close="close"> {{ props.item.pf }}
          <template v-slot:input>
            <v-text-field ref="inputPf" v-model="props.item.pf" @focus="selectText($event)" label="Enter PF No" single-line autofocus counter></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.act_arr="props" v-slot:click.native.stop="true">
        <v-edit-dialog :return-value.sync="props.item.act_arr" large @save="saveActArr(props.item)" @open="openEditActArr(props.item.act_arr)" @close="closeEditActArr"> {{getFormattedTime(props.item.act_arr)}}
          <template v-slot:input>
            <v-datetime-picker ref="editActArr" label="Select Arrival time"
             :text-field-props="textFieldProps"
             :date-picker-props="dateProps"
             :time-picker-props="timeProps"
             date-format="yyyy-MM-dd"
             time-format="HH:mm:ss"
             v-model="act_arr_formatted">
            </v-datetime-picker>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">No Report, click to retry</v-btn>
      </template>
    </v-data-table>
  </v-card-text>
    <v-card-actions>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="addRakeDialog" max-width="850px">
      <v-card>
        <v-card-text>
         <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="400px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateFormatted"
                        label="Train Date"
                        hint="DD/MM/YYYY format"
                        persistent-hint
                        required
                        :rules="dateRules"
                        prepend-icon="event"
                        @blur="editedItem.train_date = parseDate(dateFormatted)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.train_date" no-title @input="menu1 = false"></v-date-picker>
                  </v-menu>
              </v-col>
              <v-col cols="12">
                <v-combobox v-model="device" :items="devices" label="Select Tracker" return-object item-text="name" item-value="id"></v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field type="number" v-model="editedItem.train_no" label="Train No" @input="queryTrain($event)" :rules="trainNoRules" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.train_no_text" label="Train Name" ></v-text-field>
              </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.org" label="ORG" ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <masked-input v-model="editedItem.dep" label="DEP" mask="11:11" placeholder="Dep" style="font-size: 12pt;padding: 13px;border-bottom:2px solid #4fc08d;width:75pt" />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.dest" label="DEST"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <masked-input v-model="editedItem.arr" label="Arr" mask="11:11" placeholder="Arr" style="font-size: 12pt;padding: 13px;border-bottom:2px solid #4fc08d;width:75pt" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.pf" label="PF No" ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.next_train_no" label="Next Trian No" ></v-text-field>
                </v-col>
              </v-row>
          </v-container>
        </v-form>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save" :disabled="!valid">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</v-container>

</template>

<script>
import axios from 'axios'
import moment from 'moment'
import MaskedInput from 'vue-masked-input'
import _ from 'lodash'
import DatetimePicker from 'vuetify-datetime-picker'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'

import jsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'DestTrains',
  components: {
    MaskedInput
  },
  data() {
    return {
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      dialog: false,
      errors: [],
      textFieldProps: {
       appendIcon: 'event'
     },
     dateProps: {
       headerColor: 'red'
     },
     timeProps: {
       useSeconds: true,
       format: '24hr'
     },
      headers: [
        {
            text: 'Srl',
            align: 'left',
            sortable: true,
            value: 'id',
        },
        {
          text: 'Train Date',
          align: 'left',
          sortable: true,
          value: 'train_date',
        },
        {
          text: 'Rake No',
          align: 'left',
          sortable: true,
          value: 'device_name',
        },
        {
          text: 'Incoming Train',
          align: 'left',
          sortable: true,
          value: 'train_no',
        },
        {
          text: 'Last Staion',
          align: 'left',
          sortable: false,
          value: 'last_stn_code',
        },
        {
          text: 'Last Stn Arr/Dep',
          sortable: false,
          value: 'laststn_arr_or_dep'
        },
        {
          text: 'Enter Sec',
          value: 'time_entering_section'
        },
        {
          text: 'Sch Arr',
          value: 'arr'
        },
        {
          text: 'Act Arr',
          value: 'act_arr'
        },
        {
          text: 'Late in',
          value: 'late_arr'
        },
        {
          text: 'PF No',
          value: 'pf'
        },
        {
          text: 'Next Train',
          value: 'next_train_no'
        },
        {
          text: 'Out Sec',
          value: 'time_out_of_section'
        },
        {
          text: 'Actions',
          align: 'right',
          value: 'action',
          sortable: false
        },
      ],
      trains_at_pf_headers: [
        {
            text: 'Srl',
            align: 'left',
            sortable: true,
            value: 'id',
        },
        {
          text: 'Train Date',
          align: 'left',
          sortable: true,
          value: 'train_date',
        },
        {
          text: 'Rake No',
          align: 'left',
          sortable: true,
          value: 'device_name',
        },
        {
          text: 'Incoming Train',
          align: 'left',
          sortable: true,
          value: 'train_no',
        },
        {
          text: 'Last Staion',
          align: 'left',
          sortable: false,
          value: 'last_stn_code',
        },
        {
          text: 'Last Stn Arr/Dep',
          sortable: false,
          value: 'laststn_arr_or_dep'
        },
        {
          text: 'Sch Arr',
          value: 'arr'
        },
        {
          text: 'Act Arr',
          value: 'act_arr'
        },
        {
          text: 'Late in',
          value: 'late_arr'
        },
        {
          text: 'PF No',
          value: 'pf'
        },
        {
          text: 'Next Train',
          value: 'next_train_no'
        },
        {
          text: 'Actions',
          align: 'right',
          value: 'action',
          sortable: false
        },
      ],
      train: {},
      train_loading: false,
      trains: [],
      trains_avl_at_pf: [],
      train_date: new Date().toISOString().substr(0, 10),
      selectedDnTrain: {},
      selectedDnTrainIndex: -1,
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateRules: [v => !!v || 'Date is required'],
      trainNoRules: [v => !!v || 'Train No is required'],
      addRakeDialog: false,
      devices: [],
      device: {
        name: '',
        id: 0
      },
      editedItem: {
        train_date: moment().format('YYYY-MM-DD'),
        train_no:'',
        train_no_text:'',
        org: '',
        dep: '',
        dest: '',
        arr: '',
        pf: '',
        next_train_no: ''
      },
      selectableTrains: [],

      selectableTrainsHeader: [{
          text: 'Outgoing Train',
          align: 'left',
          sortable: true,
          value: 'train_no',
        },
        {
          text: 'ORG',
          value: 'org'
        },
        {
          text: 'Sch Dep.',
          value: 'dep'
        },
        {
          text: 'DEST',
          value: 'dest'
        },
        {
          text: 'Sch Arr',
          value: 'arr'
        },
      ],
      isLoading: false,
      dest: 'SDAH',
      min: -10,
      max: 60,
      lastupdate: moment().format('DD/MM/YY HH:mm:ss'),
      lastupdate_relative: moment().fromNow(),
      fetchTimer: null,
      snack: false,
      snackColor: '',
      snackText: '',
      menu1: false,
      menu2: false,
      north_south: this.$route.params.north_south,
      confirm_dialog: false,
      selectedUpTrain: {},
      act_arr_formatted: null
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep', 'actDep', 'actArr']),
    computedDateFormatted() {
      return this.formatDate(this.train_date)
    },
  },
  watch: {
    train_date(val) {
      this.dateFormatted = this.formatDate(this.train_date)
    },
    $route(to, from) {
      this.north_south = this.$route.params.north_south
      this.initialize()
    }
  },
  created() {
    this.initialize()
  },

  mounted() {
    this.fetchTimer = setInterval(() => this.initialize(), 60000);
  },

  destroyed() {
    clearInterval(this.fetchTimer);
  },
  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr']),
    formatDate(date) {
      if (!date) return null
      return moment(date).format('DD/MM/YYYY')
    },
    parseDate(date) {
      if (!date) return null
      return moment(date, ['DD/MM/YYYY']).format('YYYY-MM-DD')
    },
    confirmTrainAdd(event) {
      if (event) {
        var dep = moment(this.train_date).format("YYYY-MM-DD") + ' ' + this.selectedUpTrain.dep
        var arr = moment(this.train_date).format("YYYY-MM-DD") + ' ' + this.selectedUpTrain.arr
        if (moment(dep) > moment(arr)) {
          arr = moment(arr).add(1, 'days').format("YYYY-MM-DD HH:mm:ss")
        }
        var update_time = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')
        var pf = this.selectedDnTrain.pf && this.selectedDnTrain.pf.length > 3 ? null : this.selectedDnTrain.pf
        var train_device_map = {
          train_date: moment(this.train_date).format("YYYY-MM-DD"),
          train_no: this.selectedUpTrain.train_no,
          device_id: this.selectedDnTrain.device_id,
          device_name: this.selectedDnTrain.device_name,
          unique_device_id: this.selectedDnTrain.device_id,
          org: this.selectedUpTrain.org,
          dep: dep,
          dest: this.selectedUpTrain.dest,
          arr: arr,
          pf: pf,
          insert_time: update_time,
          update_time: update_time,
        }
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        if (this.selectedDnTrain.next_train_no) { // update
          train_device_map.id = this.selectedDnTrain.next_train_no_id
          axios.put(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
            .then(response => {
              // console.log(response)
              this.trains[this.selectedDnTrainIndex].next_train_no = this.selectedUpTrain.train_no
              this.trains[this.selectedDnTrainIndex].next_train_description = this.selectedUpTrain.dest
              this.updatePFno(this.selectedDnTrain.id, this.selectedDnTrain.pf, this.selectedUpTrain.train_no, this.selectedUpTrain.id, this.selectedUpTrain.dest)
            })
            .catch(e => {
              this.snackColor = 'error'
              this.snackText = e.response.data.error
              this.snack = true
              console.log(e)
            })
        } else { // insert
          axios.post(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
            .then(response => {
              // console.log(response)
              this.trains[this.selectedDnTrainIndex].next_train_no_id = response.data.results.insertId
              this.trains[this.selectedDnTrainIndex].next_train_no = this.selectedUpTrain.train_no
              this.trains[this.selectedDnTrainIndex].next_train_description = this.selectedUpTrain.dest
              this.updatePFno(this.selectedDnTrain.id, this.selectedDnTrain.pf, this.selectedUpTrain.train_no, response.data.results.insertId, this.selectedUpTrain.dest)
            })
            .catch(e => {
              console.log(e)
              this.snackColor = 'error'
              this.snackText = e.response.data.error
              this.snack = true
            })
        }
        this.dialog = false
        this.confirm_dialog = false
      } else {
        this.confirm_dialog = false
      }
    },
    initialize() {

      //      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      //      console.log(this.curDeviceId)
      if (!this.dialog) {
        this.isLoading = true
        var p = {
          // start_time: moment('2021-01-13 17:00:00').format('YYYY-MM-DD HH:mm:ss'),
          start_time: moment().format('YYYY-MM-DD HH:mm:ss'),
          dest: this.dest
        }
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/desttrains`, {
            params: p
          })
          .then(response => {
            this.trains = []
            this.trains_avl_at_pf = []
            var allTrains = _.filter(response.data, (o) => {
              if (this.north_south == 'north') {
                return _.indexOf(['BT','BNJ', 'KNJ', 'STB', 'LGL', 'RHA', 'GEDE', 'HNB', 'KLYM', 'KYI', 'NH', 'BP', 'GBG', 'HB', 'DTK', 'MMG','TKNR','DDC', 'DDJ','DKAE','BRPA','BWN','KWAE'], o.org) > -1;
              }
              if (this.north_south == 'south') {
                return _.indexOf(['DH', 'NAM','NMKA', 'LKPR', 'CG', 'BGB', 'BRP', 'SPR', 'BLN', 'MJT','BBDB','MGT','GOF'], o.org) > -1;
              }
            })
            allTrains = _.forEach(allTrains, (o) => {
                o.pf = o.pf ? o.pf : "Click to enter PF No.."
                o.laststn_arr_or_dep = o.last_stn_dep ? 'D ' + o.last_stn_dep : 'A ' + o.last_stn_arr
             })

             this.trains = allTrains
             // this.trains = _.filter(allTrains, (o) => {
             //    return o.act_arr == null
             // })
             // this.trains_avl_at_pf = _.filter(allTrains, (o) => {
             //     return o.act_arr != null && o.n_act_dep == null
             // })
             // console.log(this.trains_avl_at_pf)
            this.isLoading = false
            this.lastupdate = moment().format('DD/MM/YY HH:mm:ss')
            // console.log(response.data);
          })
          .catch(e => {
            console.log(e)
          })
      }
    },

    refreshData() {

    },
    addrake() {
      this.getDevices()
      this.addRakeDialog = true
    },
    close () {
      this.addRakeDialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    getDevices() {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/device/device_list`)
        .then(response => {
          // console.log(response);
          this.devices=[]
          this.devices = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    save() {
       var dep = moment(this.editedItem.train_date).format("YYYY-MM-DD") + ' ' + this.editedItem.dep
       var arr = moment(this.editedItem.train_date).format("YYYY-MM-DD") + ' ' + this.editedItem.arr
       if (moment(dep) > moment(arr)) {
         arr = moment(arr).add(1, 'days').format("YYYY-MM-DD HH:mm:ss")
       }
       // console.log(dep, arr)
       var update_time = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')
       var train_device_map = {
         train_date: moment(this.editedItem.train_date).format("YYYY-MM-DD"),
         train_no: this.editedItem.train_no,
         device_id: this.device.id,
         device_name: this.device.name,
         unique_device_id: this.device.id,
         org: this.editedItem.org,
         dep: dep,
         dest: this.editedItem.dest,
         arr: arr ,
         pf: this.editedItem.pf,
         next_train_no: this.editedItem.next_train_no,
         insert_time: update_time,
         update_time: update_time,
       }

         //console.log(train_device_map)
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

         axios.post(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
         .then(response => {
          // this.trains.push(this.editedItem)
        //  this.trains.unshift(train_device_map)
            //alert("Registered successfully")
           })
         .catch(e => {
           console.log(e)
         })
       this.close()
    },
    queryTrain($event) {
          axios.get(`${process.env.VUE_APP_API_URL}/timetable/${$event}`)
          .then(response => {
            // console.log(response);
            if ( response.data[0]) {
              this.valid = true
              this.editedItem.org = response.data[0].org
              this.editedItem.dep = response.data[0].dep
              this.editedItem.dest = response.data[0].dest
              this.editedItem.arr = response.data[0].arr
              this.editedItem.pf = response.data[0].pf
              this.editedItem.next_train_no = response.data[0].next_train_no
            } else {
              // this.valid =false
              this.editedItem.org = null
              this.editedItem.dep = null
              this.editedItem.dest = null
              this.editedItem.arr = null
              this.editedItem.pf = null
              this.editedItem.next_train_no = null
            }
          })
          .catch(e => {
            this.errors.push(e)
          })
        },
    //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;

    onRowClick($event) {
      // console.log($event);
      this.updateCurTrainDate(moment($event.train_date).format("YYYY-MM-DD"))
      this.updateCurOrg($event.org)
      this.updateCurDep($event.dep)
      this.updateActDep($event.act_dep)
      this.updateCurDest($event.dest)
      this.updateCurArr($event.arr)
      this.updateActArr($event.act_arr)
      this.$router.push({
        name: 'Positions', query: {
          train_no:$event.train_no,
          device_id: $event.device_id,
          device_name: $event.device_name
        }
      })
    },


    savePF(item) {
      this.updatePFno(item.id, item.pf, item.next_train_no, item.next_train_no_id, item.next_train_description)
    },
    cancelPF() {

    },
    addTrain() {

    },
    cancelTrain() {

    },
    open() {

    },
    openEditActArr(act_arr) {
      if (act_arr != null){
          this.act_arr_formatted = moment.utc(act_arr).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    closeEditActArr() {

    },
    saveActArr(item) {
      // console.log(this.act_arr_formatted)
      var p = {
        id: item.id,
        stn_code: 'SDAH',
        sch_arr: item.arr,
        act_arr: this.act_arr_formatted == null  ? null: moment(this.act_arr_formatted).format("YYYY-MM-DD HH:mm:ss")
      }
      // console.log(p)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.post(`${process.env.VUE_APP_API_URL}/train/update_act_arr/`, p)
        .then(res => {
          item.act_arr = p.act_arr
          this.snackColor = 'success'
          this.snackText = res.data.msg
          this.snack = true
          // console.log(res)
        })
        .catch(err => {
          this.snackColor = 'error'
          this.snackText = err
          this.snack = true
          console.log(err)
        })
    },
    selectText($event) {
      // console.log($event)
      this.$refs.inputPf.$el.querySelector('input').select()
    },
    editTrains(item) {
      this.updateCurDeviceId(item.device_id)
      this.updateCurDeviceName(item.device_name)
      this.$router.push({
        name: 'Trains'
      })
    },
    openTrainAdd(item) {
      this.selectedDnTrain = item
      this.selectedDnTrainIndex = this.trains.indexOf(item)
      this.train_date = this.getFormattedDateInISOFormat(item.train_date)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      var arr_time = this.getFormattedTime(item.arr)
      var para = {
        dest: item.dest,
        arr: arr_time
      }

      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/uptrains`, {
          params: para
        })
        .then(response => {
          this.selectableTrains = response.data
          this.selectableTrains = _.filter(response.data, (o) => {
            if (this.north_south == 'north') {
              return _.indexOf(['BT','BNJ', 'KNJ', 'STB', 'LGL', 'RHA', 'GEDE', 'HNB', 'KLYM', 'KYI', 'NH', 'BP', 'GBG', 'HB', 'DTK', 'MMG','TKNR','DDC', 'DDJ','DKAE','BRPA','BWN','KWAE'], o.dest) > -1;
            }
            if (this.north_south == 'south') {
              return _.indexOf(['DH', 'NAM','NMKA', 'LKPR', 'CG', 'BGB', 'BRP', 'SPR', 'BLN', 'MJT','BBDB','MGT','GOF'], o.dest) > -1;
            }
          })
          this.dialog = true
        })
        .catch(e => {
          console.log(e)
        })
    },
    cancelTrainAdd() {
      this.dialog = false
    },
    saveTrainAdd(item) {
      this.selectedUpTrain = item
      this.confirm_dialog = true
    },
    updatePFno(device_train_map_id, pf, next_train_no, next_train_no_id, next_train_description) {
      var pf = pf && pf.length > 3 ? null : pf
      var next_train_no_para = {
        id: device_train_map_id,
        pf: pf,
        next_train_no: next_train_no,
        next_train_no_id: next_train_no_id,
        next_train_description: next_train_description,
      }
      console.log(next_train_no_para)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.post(`${process.env.VUE_APP_API_URL}/train/updatenexttrainno/`, next_train_no_para)
        .then(res => {
          this.snackColor = 'success'
          this.snackText = res.data.msg
          this.snack = true
          console.log(res)
        })
        .catch(err => {
          this.snackColor = 'error'
          this.snackText = err
          this.snack = true
          console.log(err)
        })
    },
    createPDF() {
      const doc = new jsPDF({orientation: 'landscape',
        format:  'a4'})
        var totalPagesExp = '{total_pages_count_string}'
      let rows = [];
    this.trains.forEach(e => {
                var temp = [
                    this.getFormattedDate(e.train_date),
                    e.org,
                    e.train_no,
                    e.next_train_description,
                    e.next_train_no,
                    this.getFormattedTime(e.n_dep),
                    e.device_name,
                    e.time_entering_section,
                    e.pf.length > 2 ? '' : e.pf,
                    this.getFormattedTime(e.act_arr),
                    e.time_out_of_section
                ];
                rows.push(temp);
            });
      // Or use javascript directly:
      var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      doc.autoTable({
        theme: 'plain',
        styles: { // Defaul style
            lineWidth: 0.01,
            lineColor: 0,
            fillStyle: 'DF',
            halign: 'center',
            valign: 'bottom',
            cellWidth: 'auto',
            overflow: 'linebreak'
        },
        head: [
          [
            {content: 'Date\n1', rowSpan: 2},
            {content: 'Train\nNo\n2',rowSpan: 2},
            {content: 'Descrip-\ntion of\nTrain\n2A',rowSpan: 2},
            {content: 'Station in rear',colSpan: 9},
          ],
          [ 'Time\nLine\nClear\nenquiry\nreceived\n3','Private\nNo\n4','Identification word no\n4A','Train Line clear given\n5','Time train entering Section received\n6','Number of Token\n7','Time train arrived\n8','Train out of section sent\n9','Signature of Station Master on duty\n10']
        ],
        body: rows,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(18)
          doc.setTextColor(40)
          doc.text('EASTERN RAILWAY',pageWidth / 2, 10, 'center')
          doc.setFontSize(14)
          doc.text('OPERATING DEPARTMENT', pageWidth / 2, 16, 'center')
          doc.setFontSize(12)
          doc.text('Train Signal Register Book for Single Line and Double Line', pageWidth / 2, 20, 'center')
          doc.text('Division : Sealdah', pageWidth / 2, 24, 'center')

          // Footer
          // var str = 'Page ' + doc.internal.getNumberOfPages()
          // // Total page number plugin only available in jspdf v1.0+
          // if (typeof doc.putTotalPages === 'function') {
          //   str = str + ' of ' + totalPagesExp
          // }
          // doc.setFontSize(10)
          //
          // // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          // var pageSize = doc.internal.pageSize
          // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          // doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
          margin: { top: 30 }
      })
      doc.setProperties({
        title: "Train Signal Register"
        });
        doc.output('dataurlnewwindow');
    },
    getFormattedDate(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("DD/MM/YYYY")
    },
    getFormattedDateInISOFormat(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("YYYY-MM-DD")
    },
    getFormattedTime(t) {
      if (t) {
        return moment.utc(t).format("HH:mm:ss")
      } else {
        '--'
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },
    formatTime(t) {
      return moment(t).format("HH:mm:ss")
    },
    getColour(train) {
      if (train.act_arr) {
        let x = train.late_arr / 60
        switch (true) {
          case (x < 1):
            return 'green'
            break;
          case (x < 5):
            return '#6B8E23'
            break;
          case (x < 11):
            return 'blue'
            break;
          case (x < 21):
            return 'orange'
            break;
          case (x < 31):
            return '#FF1493'
            break;
          case (x < 1000):
            return 'red'
            break;
          default:
            return '#F5DEB3'
            break;
        }
      }
    }
  }
}
</script>
